import React from 'react';
import { Mail, Trash2, X, ArrowRight } from 'lucide-react';
import { MoveToMenu } from './guestUi';

/** The floating bar over a selection: Send invite, Move to…, Remove from event (1013-97). */
export default function GuestsBulkBar({ count, columns, busy, readOnly, onInvite, onMove, onRemove, onClear }) {
    if (!count) return null;
    const button = 'inline-flex h-8 items-center gap-1.5 rounded-lg px-2.5 text-xs font-medium hover:bg-stone-800 disabled:opacity-50';
    return (
        <div role="toolbar" aria-label="Selected guests" data-testid="guests-bulk-bar"
            className="fixed bottom-6 left-1/2 z-50 flex -translate-x-1/2 items-center gap-1.5 rounded-xl bg-stone-900 py-1.5 pl-3.5 pr-1.5 text-[13px] text-white shadow-2xl">
            <span className="pr-1 font-medium">{count} selected</span>
            <button type="button" className={button} disabled={busy || readOnly} onClick={onInvite}><Mail className="h-3.5 w-3.5" aria-hidden="true" />Send invite</button>
            <MoveToMenu columns={columns} current={null} disabled={busy || readOnly} direction="up" testId="guests-bulk-move" onPick={onMove}
                trigger={({ toggle, disabled }) => <button type="button" className={button} disabled={disabled} aria-haspopup="menu" onClick={toggle}><ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />Move to…</button>} />
            <button type="button" className={button} disabled={busy || readOnly} onClick={onRemove}><Trash2 className="h-3.5 w-3.5" aria-hidden="true" />Remove from event</button>
            <button type="button" className={button} aria-label="Clear selection" onClick={onClear}><X className="h-3.5 w-3.5" aria-hidden="true" /></button>
        </div>
    );
}
